
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Hostalinpune() {



    const cardData =
    {
        keyword: 'Hostel in Pune',
        heading: 'Shree Swami Samarth PG: Hostel in Pune',
        headingDescription: 'Shree Swami Samarth PG provides safe, comfortable, and budget-friendly hostel accommodation in Pune, perfectly suited for students, IT professionals, and working employees seeking a homely stay with modern amenities. Our hostels are located in prime areas of Pune, ensuring easy access to major IT parks, colleges, and commercial hubs for a hassle-free commute. Each room is well-furnished, clean, and designed for convenience with proper storage, study-friendly setups, and comfortable bedding. Residents enjoy essential facilities like high-speed WiFi, 24x7 water supply, hygienic home-cooked meals, CCTV surveillance, and regular housekeeping for a secure and stress-free lifestyle. With disciplined management, affordable rent plans, and a supportive environment, Shree Swami Samarth PG’s hostels in Pune stand out as the perfect choice for individuals looking for reliable, cost-effective, and comfortable living solutions in the city.',

        top: 'Top Facilities at Shree Swami Samarth PG ',

"topFacilities": [
  {
    "title": "Comfortable and Well-Furnished Rooms",
    "description": "Hostels in Pune offer neatly designed, fully furnished rooms with beds, wardrobes, study desks, and chairs, ensuring comfort for students and working professionals. Options include single, double, and triple sharing to fit varying budgets and privacy needs. Rooms are kept airy, clean, and well-lit with natural light, promoting both productivity and relaxation. Interiors are simple yet functional, providing a balance of homeliness and practicality. Whether for long-term academic stays or professional commitments, these hostels provide reliable and comfortable accommodation."
  },
  {
    "title": "Nutritious and Affordable Meals",
    "description": "Most hostels in Pune include freshly cooked, hygienic meals as part of their package. Residents are served breakfast, lunch, and dinner daily, prepared with an emphasis on taste and nutrition. Vegetarian and dietary-specific meals are often available to cater to diverse preferences. Kitchens maintain strict cleanliness standards, ensuring food safety. With meals included, residents save time and money compared to eating outside every day. This makes hostel life not only convenient but also healthier and budget-friendly."
  },
  {
    "title": "High-Speed Wi-Fi and Connectivity",
    "description": "To meet the digital needs of today’s youth, Pune hostels provide reliable high-speed Wi-Fi across rooms and common areas. Students benefit from seamless online learning, research, and project submissions. Professionals enjoy smooth remote work setups, video conferencing, and team collaboration. Connectivity remains stable even with multiple users, making it perfect for shared living. With uninterrupted access, residents can balance both academic and professional tasks efficiently while staying connected with family and friends."
  },
  {
    "title": "24/7 Security and Safe Environment",
    "description": "Safety is a top priority in Pune hostels, which are equipped with CCTV surveillance, biometric entry, and on-site security personnel. Visitor entry is monitored to ensure privacy and protection of residents. Many hostels also employ wardens to oversee daily operations, adding an extra layer of supervision. Located in well-developed localities, Pune hostels provide peace of mind for both residents and their families. This secure environment ensures a stress-free stay for students and professionals alike."
  },
  {
    "title": "Prime Locations Across the City",
    "description": "Hostels in Pune are strategically located near educational institutions, IT parks, shopping malls, and transport hubs. Areas like  Viman Nagar, Kothrud, and Hinjewadi are popular for their excellent connectivity. Residents enjoy quick access to public transport, cabs, and daily essentials, making commuting simple and convenient. Proximity to cafes, gyms, and entertainment centers ensures a lively lifestyle. Staying in these hostels provides a blend of city convenience and residential comfort."
  },
  {
    "title": "Housekeeping and Laundry Services",
    "description": "To maintain hygiene, hostels in Pune offer regular housekeeping services, keeping rooms and common spaces neat and clean. Garbage disposal, bathroom sanitation, and floor cleaning are done routinely. Many hostels also provide laundry services or washing machine access, saving time for busy students and professionals. These services allow residents to focus on their education or careers without worrying about daily chores. A clean living environment also promotes health and overall well-being."
  },
  {
    "title": "Recreational and Common Facilities",
    "description": "Hostels in Pune are not just about living spaces—they also encourage community bonding. Shared lounges, TV rooms, indoor games, and reading corners create spaces for relaxation and interaction. Many hostels organize cultural events, workshops, or group study sessions to enhance the experience. These facilities help residents feel connected, reducing loneliness and making hostel life enjoyable. A balance of academic focus and leisure ensures a holistic lifestyle for residents."
  },
  {
    "title": "Affordable and Transparent Pricing",
    "description": "One of the biggest advantages of Pune hostels is their affordability compared to flats or PGs. Monthly rents usually cover accommodation, meals, Wi-Fi, and housekeeping, making them cost-effective. Pricing varies depending on location and amenities, with shared rooms starting as low as ₹5,000–₹7,000/month, and premium hostels ranging from ₹12,000–₹18,000/month. Transparent rental policies with no hidden charges make financial planning easy. This affordability, combined with excellent facilities, makes hostels in Pune a smart choice."
  }
],


"services": [
  {
    "name": "Hostel in Pune",
    "description": "Shree Swami Samarth Hostel in Pune offers a fully managed, comfortable, and secure living experience for students and professionals. Located in key areas like Balewadi, the hostel provides fully furnished rooms, daily meals, Wi-Fi, and 24/7 support—all at affordable rates. Ideal for anyone seeking a worry-free stay in Pune with all essentials included."
  },
  {
    "name": "Boys Hostel in Pune",
    "description": "Looking for a Boys Hostel in Pune? Shree Swami Samarth PG provides safe, well-maintained accommodation for male students and working professionals. We offer both single and shared rooms with regular housekeeping, hygienic food, high-speed internet, and peaceful surroundings near tech parks and educational hubs."
  },
  {
    "name": "Girls Hostel in Pune",
    "description": "Shree Swami Samarth PG runs a safe and secure Girls Hostel in Pune with female staff, CCTV surveillance, and dedicated support. Ideal for students and working women, our hostel includes furnished rooms, nutritious meals, and a calm environment for studying or unwinding after work. Locations are carefully chosen near transport links and commercial zones."
  },
  {
    "name": "Student Hostel in Pune",
    "description": "Shree Swami Samarth Student Hostel in Pune is designed to support academic life with quiet rooms, fast internet, and healthy food. With easy access to coaching centers and colleges, students can focus on studies while enjoying essential amenities like laundry, mess service, and round-the-clock support."
  },
  {
    "name": "Working Professionals Hostel in Pune",
    "description": "Our Hostel for Working Professionals in Pune provides a clean, peaceful, and hassle-free environment near major tech parks and commercial areas. Shree Swami Samarth PG ensures quick commute access, in-house food service, Wi-Fi, and flexible stay plans for contract employees, interns, or full-time staff."
  },
  {
    "name": "Affordable Hostel in Pune",
    "description": "Get the best value with our Affordable Hostel in Pune. At Shree Swami Samarth PG, you’ll find low-cost living with zero compromise on hygiene, food, and security. Perfect for students, interns, and early-career professionals, our budget-friendly hostels come with shared or private room options—all under a fixed monthly plan."
  },
  {
    "name": "Furnished Hostel in Pune",
    "description": "Move in instantly with our Furnished Hostel in Pune, where each room includes a bed, mattress, wardrobe, study desk, and fan. Shree Swami Samarth PG ensures residents enjoy a ready-to-live experience with Wi-Fi, cleaning, laundry, and food included—ideal for students and working professionals."
  },
  {
    "name": "Luxury Hostel in Pune",
    "description": "Upgrade your living with Shree Swami Samarth’s Luxury Hostel in Pune. Our premium PG offers AC rooms, smart TVs, attached washrooms, and fine interiors—along with chef-cooked meals and professional housekeeping. Perfect for those who want comfort, style, and amenities all under one roof."
  },
  {
    "name": "Monthly Hostel in Pune",
    "description": "Need a flexible stay option? Our Monthly Hostel in Pune offers zero lock-in contracts and flat monthly rates that include rent, food, internet, and laundry. Whether you're on a short internship or temporary transfer, Shree Swami Samarth PG makes it easy to move in and out without the stress of long-term commitments."
  },
  {
    "name": "Hostel Near IT Parks in Pune",
    "description": "Stay close to your workplace with our Hostel near IT Parks in Pune. Located conveniently near Hinjewadi,  and Balewadi tech zones, Shree Swami Samarth PG helps techies avoid long commutes. Fully furnished rooms, meals, and high-speed Wi-Fi make it a perfect choice for professionals working in Pune's IT hubs."
  },
  {
    "name": "Hostel With Food in Pune",
    "description": "Shree Swami Samarth PG offers a Hostel with Food in Pune, where all meals are prepared in-house with attention to taste, hygiene, and nutrition. Residents enjoy daily breakfast and dinner as part of their stay—ideal for those who prefer the comfort of homely meals without extra cost or effort."
  },
  {
    "name": "Private Hostel in Pune",
    "description": "Looking for privacy and peace? Our Private Hostel in Pune offers single occupancy rooms with personal storage, attached washrooms, and work desks. Shree Swami Samarth PG is ideal for students preparing for exams or professionals working remotely who value independence and quiet living."
  }
],
"tableData": [
  ["Hostel in Pune", "Boys Hostel in Pune"],
  ["Girls Hostel in Pune", "Student Hostel in Pune"],
  ["Working Professionals Hostel in Pune", "Affordable Hostel in Pune"],
  ["Furnished Hostel in Pune", "Luxury Hostel in Pune"],
  ["Monthly Hostel in Pune", "Hostel Near IT Parks in Pune"],
  ["Hostel With Food in Pune", "Private Hostel in Pune"]
],




"whychoose": [
    {
        "WhyChooseheading": "Reliable and Affordable Hostel in Pune",
        "WhyChoosedescription": "Shree Swami Samarth PG offers a top-rated hostel experience in Pune, known for clean, secure, and budget-friendly accommodations. Whether you're a student, intern, or working professional, our hostel is designed to offer a comfortable and stress-free living experience in the heart of the city."
    },
    {
        "WhyChooseheading": "Prime Locations Across Pune’s Key Areas",
        "WhyChoosedescription": "Our hostels are located in prime neighborhoods like  Aundh, Balewadi, and Viman Nagar, with easy access to IT hubs, colleges, coaching centers, and shopping areas. With public transport and essential amenities nearby, daily life is convenient and well-connected."
    },
    {
        "WhyChooseheading": "Furnished Rooms with Flexible Sharing Options",
        "WhyChoosedescription": "Choose from single, double, or triple-sharing rooms based on your comfort and budget. All rooms come furnished with beds, wardrobes, study desks, and fans. Common areas and attached or shared bathrooms are cleaned regularly and well-maintained."
    },
    {
        "WhyChooseheading": "Healthy, Home-Style Food Served Daily",
        "WhyChoosedescription": "We provide nutritious vegetarian and non-vegetarian meals freshly prepared in-house. Our kitchen follows strict hygiene protocols and serves three meals a day along with purified RO drinking water to ensure your health is never compromised."
    },
    {
        "WhyChooseheading": "Affordable Rent with All Facilities Included",
        "WhyChoosedescription": "Enjoy an all-inclusive rent model covering your stay, food, high-speed Wi-Fi, laundry, housekeeping, and electricity—no hidden costs or surprise charges. Ideal for those seeking predictable monthly expenses with full convenience."
    },
    {
        "WhyChooseheading": "Strong Focus on Cleanliness and Hygiene",
        "WhyChoosedescription": "We maintain high cleanliness standards through daily housekeeping, regular sanitization, and pest control. Bathrooms, kitchens, and common spaces are monitored to ensure a clean and healthy living environment at all times."
    },
    {
        "WhyChooseheading": "Secure Environment with 24/7 Safety Measures",
        "WhyChoosedescription": "Our hostels in Pune are equipped with biometric entry, CCTV surveillance, and resident wardens. Whether you’re coming home late or studying overnight, you can rest easy knowing your safety is our top priority."
    },
    {
        "WhyChooseheading": "Friendly Community and Round-the-Clock Support",
        "WhyChoosedescription": "From roommate coordination to maintenance help, our on-site support team is available 24/7 to assist. We foster a respectful and welcoming environment, helping residents feel supported, whether they’re staying for a month or long-term."
    }
]

















    }

const faqData = [
    {
        question: "How can I book a hostel in Pune at Shree Swami Samarth PG?",
        answer: "You can book a hostel room in Pune by calling us at +91 9594917913 or visiting our property directly. Online booking support is also available."
    },
    {
        question: "What amenities are provided at your hostel in Pune?",
        answer: "Our hostel in Pune includes fully furnished rooms, high-speed Wi-Fi, daily housekeeping, hot water, vegetarian meals, laundry service, and CCTV security."
    },
    {
        question: "Is your hostel in Pune suitable for both students and working professionals?",
        answer: "Yes, our hostel welcomes both students and working professionals, offering a peaceful, clean, and safe living environment."
    },
    {
        question: "Do you provide separate hostel accommodations for boys and girls in Pune?",
        answer: "Yes, we offer separate and secure hostel accommodations for boys and girls with proper privacy and safety measures."
    },
    {
        question: "Is food included in the hostel fees at your Pune property?",
        answer: "Yes, breakfast, lunch, and dinner (vegetarian) are included in the hostel fees."
    },
    {
        question: "What is the monthly rent for your hostel in Pune?",
        answer: "Rent varies depending on room occupancy (single, double, or triple) and additional amenities. Contact us for updated pricing."
    },
    {
        question: "How secure is your hostel in Pune for residents?",
        answer: "Our hostel is equipped with 24/7 CCTV surveillance, secure entry, and on-site staff to ensure a safe stay for all residents."
    },
    {
        question: "Is there a minimum stay requirement at your hostel in Pune?",
        answer: "Yes, the minimum stay is one month. Shorter stays may be allowed based on availability and conditions."
    },
    {
        question: "Are housekeeping and laundry services available at the hostel?",
        answer: "Yes, we provide regular housekeeping and optional laundry services for all residents."
    },
    {
        question: "How do I contact Shree Swami Samarth PG for hostel bookings in Pune?",
        answer: "For bookings and inquiries, you can call us at +91 9594917913. Our team will assist you with availability and property visits."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Nikhil Patwardhan',
        designation: 'Software Developer, Infosys Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“I stayed at Shree Swami Samarth hostel in Pune for 6 months. The rooms were clean, food was homely, and I felt completely secure throughout my stay.”',
    },
    {
        name: 'Ms. Rutuja Salunkhe',
        designation: 'B.Pharm Student, Pune University',
        rating: [1, 1, 1, 1, 1],
        text: '“This hostel in Pune has been the best choice for my studies. Peaceful environment, supportive staff, and all facilities are top-notch.”',
    },
];




















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9209169761",
            "+91 9096665072",

        ],
        email: "reservation@swamisamarthpg.com "
    };


     const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " PG in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "  Single Room PG in Pune",
        },
        
        {
            place: "/images/keyword/4.jpg",
            text: "  Best Luxury PG in Pune",
        },
       
       
        {
            place: "/images/keyword/13.jpg",
            text: "  Hostel in Pune",
        },

        {
            place: "/images/keyword/15.jpg",
            text: " PG for Working Professionals Pune",
        },
        
        {
            place: "/images/keyword/19.jpg",
            text: "  Paying Guest Near Hinjewadi IT Park Pune",
        },
        

    ];


    const images = [
        { src: "./images/gallery/1.jpg", alt: "Image 1" },
        { src: "./images/gallery/2.jpg", alt: "Image 1" },
        { src: "./images/gallery/3.jpg", alt: "Image 1" },
        { src: "./images/gallery/4.jpg", alt: "Image 1" },
        { src: "./images/gallery/5.jpg", alt: "Image 1" },
        { src: "./images/gallery/6.jpg", alt: "Image 1" },
        { src: "./images/gallery/7.jpg", alt: "Image 1" },
        { src: "./images/gallery/8.jpg", alt: "Image 1" },
        { src: "./images/gallery/9.jpg", alt: "Image 1" },

    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Hostel in Pune",
  "image": "https://swamisamarthpg.com/assets/images/hostel-in-pune.jpg", // Replace with actual image URL
  "description": "Affordable and furnished hostels in Pune for boys, girls, students, and working professionals. Options include luxury stays, monthly rent, hostels near IT parks, and hostels with food facilities.",
  "brand": {
    "@type": "Brand",
    "name": "Shree Swami Samarth PG"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8500",  // Replace with actual price if needed
    "availability": "https://schema.org/InStock",
    "url": "https://swamisamarthpg.com/hostel-in-pune"  // Replace with actual page URL if different
  }
};







    return (
        <div>
<Helmet>
  <title>Hostel in Pune | Affordable & Furnished Hostels for Students & Professionals</title>
  <meta 
    name="description" 
    content="Find affordable and furnished hostels in Pune for boys, girls, students, and working professionals. Luxury options, monthly rents, and hostels near IT parks available with food facilities." 
  />
  <meta 
    name="keywords" 
    content="Hostel in Pune, Boys Hostel in Pune, Girls Hostel in Pune, Student Hostel in Pune, Working Professionals Hostel in Pune, Affordable Hostel in Pune, Furnished Hostel in Pune, Luxury Hostel in Pune, Monthly Hostel in Pune, Hostel Near IT Parks in Pune, Hostel With Food in Pune, Private Hostel in Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/14.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF6403', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topFacilities.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                          

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Shree Swami Samarth PG</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                {/* <FAQKeyword faqs={faqData} /> */}
                <Accordion data={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF6403',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF6403' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919209169761" className="d-block  text-white">+91 9209169761</a>
                                                <a href="tel:+919096665072" className="d-block  text-white">+91 9096665072</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:reservation@swamisamarthpg.com " className=" text-white d-block">
                                                    reservation@swamisamarthpg.com 
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Shree Swami Samarth PG  <br />
                                                        M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Hostalinpune;